import React, { useState, useEffect } from 'react';
import './DeleteConfirmationModal.css';

const DeleteConfirmationModal = ({ isOpen, onClose, onConfirm, metricName }) => {
  const [typedName, setTypedName] = useState('');
  const [isConfirmEnabled, setIsConfirmEnabled] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setTypedName('');
      setIsConfirmEnabled(false);
    }
  }, [isOpen, metricName]);

  useEffect(() => {
    setIsConfirmEnabled(typedName === metricName);
  }, [typedName, metricName]);

  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleConfirm = () => {
    if (isConfirmEnabled) {
      onConfirm();
      onClose();
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && isConfirmEnabled) {
      handleConfirm();
    }
  };

  return (
    <div className="delete-modal-backdrop" onClick={handleBackdropClick}>
      <div className="delete-modal">
        <div className="delete-modal-header">
          <h3>Delete Metric</h3>
        </div>
        <div className="delete-modal-content">
          <p>Are you sure you want to delete <strong>"{metricName}"</strong>?</p>
          <p className="delete-warning">This action cannot be undone.</p>
          <div className="confirmation-input">
            <label htmlFor="metric-name-confirm">
              Type the metric name to confirm deletion:
            </label>
            <input
              id="metric-name-confirm"
              type="text"
              value={typedName}
              onChange={(e) => setTypedName(e.target.value)}
              onKeyPress={handleKeyPress}
              placeholder={metricName}
              autoFocus
            />
          </div>
        </div>
        <div className="delete-modal-actions">
          <button 
            className="cancel-btn"
            onClick={onClose}
          >
            Cancel
          </button>
          <button 
            className={`delete-confirm-btn ${!isConfirmEnabled ? 'disabled' : ''}`}
            onClick={handleConfirm}
            disabled={!isConfirmEnabled}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;
